import * as React from 'react';
import {styledDiv} from '@packages/utilities/styled';
import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';
import {
  type ContextualExpression,
  stripAll,
} from '@packages/utilities/contextual-expression';

import {FinePrint} from '@packages/systems/design-system/Text';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';

const ItemGrid = styledDiv(({theme: {gutters}}) => ({
  display: 'grid',
  gridGap: gutters.x8,
  gridTemplateColumns: 'repeat(3, min-content)',
}));

const NameValueType = wast.TRecord({
  Name: w.withSystem(
    {isFullWidth: true, isBindable: false, bindUIVariant: 'custom'},
    w.withMeta({placeholder: 'Enter name...'}, wast.TText)
  ),
  Value: w.withSystem(
    {isFullWidth: true, isBindable: false, bindUIVariant: 'custom'},
    w.withMeta({placeholder: 'Enter value...'}, wast.TText)
  ),
});

export const NameAndValueType = w.TypeImplementation.Alias({
  type: NameValueType,
  render: function RenderNameAndValue({expr, dispatch}) {
    return <ExpressionEditor dispatch={dispatch} expression={expr} />;
  },
  renderSummary: function RenderNameValueSummary({
    expr,
  }: {
    expr: ContextualExpression;
  }) {
    const {name, value} = React.useMemo(() => {
      const stripped = stripAll(expr);
      const rec = w.Expressions.getRecord(stripped);
      const nameExpr = rec?.Name;
      const valueExpr = rec?.Value;
      return {
        name: nameExpr ? w.Expressions.getText(nameExpr) : null,

        value: valueExpr ? w.Expressions.getText(valueExpr) : null,
      };
    }, [expr]);

    if (!name || !value) {
      return <FinePrint muted>{'Enter a name and value...'}</FinePrint>;
    }

    return (
      <ItemGrid>
        <FinePrint dim>{name}</FinePrint>
        <span>:</span>
        <FinePrint>{value}</FinePrint>
      </ItemGrid>
    );
  },
});
